<div class="content_container">
    <div class="logo_container">
        <a routerLink="/">
            <img src="../../../assets/AMADEO LOGO 2.png" class="logo">
        </a>
    </div>
    <div class="page_title">REGISTER</div>

    <div class="form_container">
      <div class="alert alert-danger" role="alert" *ngIf="errorMsg">
        {{errorMsg}}
      </div>
      <div class="alert alert-success" role="alert" *ngIf="successMsg">
        {{successMsg}}
      </div>
      <form (ngSubmit)="onSubmit()" #f="ngForm" class="row g-3">
          <div class="form-group col-md-6">
            <label for="name">Partner Company Name<span class="required">*</span></label>
            <input type="text" class="form-control" id="name" name="partnerName" [(ngModel)]="data.name" required>
          </div>
          <div class="form-group col-md-6">
            <label for="email">Email<span class="required">*</span></label>
            <input type="email" class="form-control" id="email" name="email" [(ngModel)]="data.email">
          </div>
          <div class="form-group col-md-6">
            <label for="partnerCode">System Code</label>
            <input type="text" class="form-control" id="partnerCode" name="partnerCode" [(ngModel)]="data._PartnerCode">
          </div>
          <div class="form-group col-md-6">
            <label for="license">License</label>
            <input type="text" class="form-control" id="license" name="license" [(ngModel)]="data._License">
          </div>
          
          <div class="form-group col-md-6">
            <label for="password">Password<span class="required">*</span></label>
            <input type="password" class="form-control" name="password" id="password" 
              [(ngModel)]="data._Password" required minlength="4">
          </div>
          <div class="form-group col-md-6">
            <label for="repeatpassword">Repeat Password<span class="required">*</span></label>
            <input type="password" class="form-control" id="repeatpassword" name="repeatPassword" 
              [(ngModel)]="data._PasswordRepeat" required minlength="4">
          </div>
          <div class="form-group col-md-6">
            <label for="country">Country<span class="required">*</span></label>
            <select class="form-control" id="country" name="country" [(ngModel)]="data.countryId" required>
              <option *ngFor="let country of countries" [value]="country.id">{{ country._CountryName}}</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="contactPerson">Contact Person<span class="required">*</span></label>
            <input type="text" class="form-control" id="contactPerson" name="contactPerson" [(ngModel)]="data.contactPerson" required>
          </div>
          <div class="form-group col-md-6">
            <label for="partnerType">Partner Type<span class="required">*</span></label>
            <select class="form-control" id="partnerType" name="partnerType" [(ngModel)]="data.partnerType" required>
              <option *ngFor="let item of partnerTypes" [value]="item.value">{{ item.name }}</option>
            </select>
          </div>
          <div class="form-group col-md-6">
              <label for="installationCategory">Installation Category<span class="required">*</span></label>
              <select class="form-control" id="installationCategory" name="installationCategories" [(ngModel)]="data.installationCategoryID" required>
                <option *ngFor="let item of installationCategories" [value]="item.installationCategoryID">{{ item._Name }}</option>
              </select>
          </div>
          <div class="form-group col-12">
              <button type="submit" class="btn btn-success enter_btn" [disabled]="!f.valid || isSubmitLoading">
                  <span *ngIf="!isSubmitLoading">Register</span>
                <span *ngIf="isSubmitLoading">Submitting... </span>
              </button>
              <div class="forgot_password">
                  <span class="required">*</span> mandatory fields
              </div>
          </div>
      </form>
    </div>
</div>



<table>
  <thead></thead>
</table>